<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-title">{{ title }}</h2>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ message }}</p>

    <div class="products-list">
      <div *ngFor="let product of products; let i = index" class="product-item" [class.product-disabled]="disabledProducts[i]">
        <div class="product-header">
          <span class="product-number">{{ i + 1 }}.</span>
          <span class="product-name">{{ product.productName }}</span>
        </div>

        <div *ngIf="disabledProducts[i]" style="background-color: #e8f5e9; border: 1px solid #4caf50; border-radius: 4px; padding: 8px 14px; margin-bottom: 8px; display: flex; align-items: center; gap: 8px;">
          <i class="fa fa-check-circle" style="color: #4caf50; font-size: 16px;"></i>
          <span style="color: #2e7d32; font-size: 13px; font-weight: 500;">Project title "{{ projectTitles[i] }}" is already saved</span>
        </div>

        <mat-form-field *ngIf="!disabledProducts[i]" appearance="outline" class="project-title-field">
          <mat-label>Project Title</mat-label>
          <input
            matInput
            [(ngModel)]="projectTitles[i]"
            [placeholder]="product.productName"
            [maxlength]="maxTitleLength"
            required
            (input)="validateTitle(i)"
            (blur)="markTouched(i)"
          />
          <mat-hint align="end">{{ projectTitles[i]?.length || 0 }}/{{ maxTitleLength }}</mat-hint>
          <mat-error *ngIf="titleTouched[i] && (!projectTitles[i] || projectTitles[i].trim() === '')">
            Project title is required
          </mat-error>
        </mat-form-field>
        <div *ngIf="duplicateFlags[i]" style="color: #f44336; font-size: 12px; margin-top: -16px; margin-bottom: 8px; padding-left: 14px;">
          Project title already exists. Please choose a different name.
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      class="confirm-btn"
      [disabled]="!isValid()">
      <span *ngIf="!isChecking">Continue</span>
      <span *ngIf="isChecking"><i class="fa fa-spinner fa-spin"></i> Checking...</span>
    </button>
  </mat-dialog-actions>
</div>
